import PinForm from './PinForm'
import {onSubmitForm, pageRequest} from 'actions/employees/pin'
import {connect} from 'react-redux'
import {isDirty} from 'redux-form'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {browserHistory} from 'react-router'
import {askConfirmAction} from 'actions/confirm-action/index'
import {push} from 'react-router-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {LeftColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import {SUBMITTING_GET_PERMISSIONS} from 'actions/employees/pin/constants'
import SaveAppPermissionModal from './SaveAppPermissionModal'
import {hideSaveAppPermissionModal} from 'actions/employees/pin/pin'
import styles from './Pin.css'
import MenuTitle from 'components/MenuTitle'

class Pin extends React.Component {
  componentDidMount () {
    const {dispatch, user, expired} = this.props
    if (expired) {
      browserHistory.push('/settings/billing')
    } else {
      dispatch(pageRequest({user}))
      browserHistory.listenBefore((location) => {
        // this is still hacky, don't copy paste this
        if (this.props.isDirtyPin && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    }
  }

  render () {
    const {submitting, allowedFields, showSaveAppPermissionModal, saveAppPermissionModal} = this.props
    const accessDenied = !allowedFields.length
    const onLoadData = submitting === SUBMITTING_GET_PERMISSIONS

    // we use tricky open right column to separate left-right evenly and loadingspinner to show accessDenies
    return (
      <div>
        <MenuTitle menuTitle='PIN Access' />
        <div className='col-md-12 content-pin-access'>
          <PageWrapper>
            {(onLoadData || accessDenied) && <LeftColumnWrapper openRightColumn={false}>
              <div className={styles['loading-wrapper']}>
                <NoDataAndLoading
                  showLoadingSpinner={onLoadData}
                  noDataToDisplay={accessDenied}
                  image={require('assets/images/access-denied.png')}
                  title='Access Denied'
                  description="You're not authorized to access this privilege."
                  />
              </div>
              </LeftColumnWrapper>}
            {!onLoadData && <LeftColumnWrapper openRightColumn>
              <PinForm onSubmit={this._onSubmit}
                allowedFields={allowedFields}
                />
              </LeftColumnWrapper>}
            <ConfirmActionModal />
            <SaveAppPermissionModal
              show={showSaveAppPermissionModal}
              onConfirm={this._onConfirmSaveAppPermissionModal}
              message={saveAppPermissionModal.message}
            />
          </PageWrapper>
        </div>
      </div>
    )
  }

  _onSubmit = (values) => {
    const {dispatch, user} = this.props
    dispatch(onSubmitForm({values, user}))
  }
  _onConfirmSaveAppPermissionModal = () => {
    const {dispatch} = this.props
    dispatch(hideSaveAppPermissionModal())
  }
}

function mapStateToProps (state) {
  const {submitting, allowedFields, showSaveAppPermissionModal, saveAppPermissionModal} = state.employee.pin
  const {user} = state.moka
  const {expired} = state.subscriptionExpired
  return {
    isDirtyPin: isDirty('pin')(state),
    nextAction: state.confirmAction.nextAction,
    submitting,
    user: {
      id: user.id,
      is_owner: user.is_owner,
      is_manager: user.is_manager
    },
    allowedFields,
    showSaveAppPermissionModal,
    saveAppPermissionModal: {
      message: saveAppPermissionModal.message
    },
    expired
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Pin)




// WEBPACK FOOTER //
// ./app/pages/Employees/Pin/Pin.js